import {
  CreateExportRequestV1,
  EXPLORER_API_BASE,
  ExportsQueryV1,
  ExportsResponseV1,
  ExportV1,
} from "@strust/contracts";
import { defineEndpoint } from "../../../shared/api/endpoint.ts";

// `POST /exports` (answers a CSV for up to 10,000 rows, else 202 + ExportV1), `GET /exports` and
// `GET /exports/{id}/download` (302 to a 5-minute presigned URL), all `explorer.export`.

export const createExportEndpoint = defineEndpoint({
  method: "POST",
  path: "/exports",
  body: CreateExportRequestV1,
  response: ExportV1,
});

export const listExportsEndpoint = defineEndpoint({
  method: "GET",
  path: "/exports",
  query: ExportsQueryV1,
  response: ExportsResponseV1,
});

/**
 * The download is a browser navigation, not a fetch: the API answers `302` to the presigned file
 * URL, which the browser follows and saves. The link is offered only for a `ready` export.
 */
export function exportDownloadHref(exportId: string): string {
  return `${EXPLORER_API_BASE}/exports/${encodeURIComponent(exportId)}/download`;
}
